<template>
	<div class="products">
		<div v-for="item of items" :key="item.id" class="products__product product">
			<a-tag class="product__card">
				<div class="product__user">{{ item.email }}</div>
				<span v-if="item.product">
					Источник:
					<a-tag color="purple" class="product__name">{{ item.product.name }}</a-tag>
				</span>
			</a-tag>
		</div>
	</div>
</template>

<script>
export default {
	name: "UserTableProducts",
	props: {
		items: { type: Array, required: true }
	},
	methods: {
		/**
		 * Обработать отвязку продукта
		 */
		onUnlink(product) {
			this.$emit("unlink", product)
		}
	}
}
</script>

<style lang="scss" scoped>
.products {
	display: flex;
	flex-wrap: wrap;

	&__control {
		margin-top: 10px;
	}
}

.product {
	margin-bottom: 20px;

	&:last-child {
		margin-bottom: 0;
	}

	&__card {
		margin-left: 15px;
		margin-bottom: 15px;
		padding: 15px;
	}
	&__user {
		font-weight: bold;
	}
}
</style>
